/**
 * Store links for the shared "Install The Free App" block (#1088), and the
 * website's get-the-app link (#1264).
 *
 * The direct store URLs are the ones the home page has always used (the same
 * values as `LinkChanged.tsx`). The store badges, the footer, `/app` and
 * `/free-trial` use them (`APP_STORE_URL` / `PLAY_STORE_URL`): an Apple badge
 * goes to the App Store and a Google badge to Google Play.
 *
 * A single open-or-install link uses `GET_APP_LINK` instead: GetAppCard's
 * phone button, the success pages' INSTALL THE APP, the series pages' app icon
 * and the sign-up's code to scan. It is on the deep-link domain, so a phone
 * with the FarmFLiX app opens the app (the app claims every path on
 * link.farmflix.tv). A phone without it, or a computer, reaches the website's
 * `/link/get-app`, which
 * sends it to `/get-app`: an iPhone goes on to the App Store, an Android phone
 * to Google Play and anything else to `/app` (`GetAppRedirect.tsx`).
 *
 * #1264: the smart.link (Kochava) links the website used before sent every
 * phone to farmflix.tv/trybuy, the sign-up page, instead of a store, and are
 * no longer used anywhere on the website.
 */

export const APP_STORE_URL =
  "https://apps.apple.com/us/app/farmflix/id1490609587";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.farmflix&hl=en_GB&gl=US";

// The sign-up's code to scan (`assets/signup-get-app-qr.png`) holds this link;
// remake the image if it changes.
export const GET_APP_LINK = "https://link.farmflix.tv/get-app";
